window.addEventListener('load', function(){

    /* 카드 헤더 추가 */
    const productListColumns = document.querySelectorAll(".list-product-items .m-mixed-layout__inner .m\\:column");
    console.log(productListColumns);
    productListColumns.forEach(column => {
      const nameElement = column.querySelector(".list-product-items .m-product-card__name");
      if (!nameElement) return;
  
      const text = nameElement.textContent;
      const match = text.match(/\[([^\]]+)\]/); // [내용] 추출
  
      if (match) {
        const topTitle = document.createElement("div");
        topTitle.className = "top_title";
        topTitle.textContent = `[${match[1]}]`;
  
        column.insertBefore(topTitle, column.firstChild); // 가장 첫 자식으로 삽입
      }
    });

    // 현재 url과 동일한 탭 강제 클릭
    const url = window.location.href.toLowerCase().replace(/[\s-]/g, '');
    const cateHeaders = document.querySelectorAll('.m-collection-card__inner');
    const tabHeaders = document.querySelectorAll('.m-tab-header');
    
    // Collection List
    cateHeaders.forEach(cate => {
      const cateText = cate.textContent.trim().toLowerCase().replace(/[\s-]/g, '');
      if (url.includes(cateText)) {
        cate.classList.add('active');
      }
    
      if (url.includes('frontpage')) {
        cateHeaders[0].classList.add('active');
      }

      cate.addEventListener('click', function () {
        const link = cate.querySelector('a.m-collection-card__link');
        if (link && link.href) {
          window.location.href = link.href;
        }
      });
    });
    
    // Product Tabs
    tabHeaders.forEach(tab => {
      const tabText = tab.textContent.trim().toLowerCase().replace(/[\s-]/g, '');
      if (url.includes(tabText)) {
        tab.click();
      }
    });

  
});